<template>
  <section class="assessmentSection">
    <div class="homeOverviewContainer">
      <template v-if="loading">Loading...</template>

      <div v-if="!address">
        <div class="empty-container text-center">
          <h1>
            Enter the address of the property to protect to get an instant
            quote?
          </h1>
          <gmap-autocomplete
            @place_changed="getAddressData"
            ref="autocomplete"
            :value="address"
            placeholder="What's your address?"
          ></gmap-autocomplete>
          <button class="button">Get Started</button>
        </div>
      </div>

      <template v-if="Object.keys(homeData).length">
        <div class="flex">
          <div class="homeInfo">
            <!-- Home Box -->
            <div class="flex">
              <div>
                <img
                  class="map-image"
                  :src="homeData.mapImage"
                  :alt="address"
                  width="100"
                />
              </div>
              <div>
                <img
                  src="/img/location-marker-home.png"
                  class="map-marker"
                  alt="map marker"
                />
                <div class="text-blue text-bold">{{ address }}</div>
                <a class="text-gray-darker" href="#" @click="reset"
                  >Not your address?</a
                >
              </div>
            </div>

            <h2>We found your home!</h2>
            <p v-if="!homeData.hasHomeData">But we had trouble finding details about your home. <br> Please enter your home information below.</p>
            <p v-if="homeData.hasHomeData">Edit any information that is wrong by clicking the button</p>

            <div
              class="home-image-mobile"
              :style="`background-image: url(${homeData.image})`"
            ></div>

            <div class="mb-4">
              <DataCard
                label="Basement"
                type="boolean"
                :value="lead.homeBasement"
                @input="value => handleChange('homeBasement', value)"
              />
            </div>
            <div class="mb-4">
              <DataCard
                label="Floors"
                :value="lead.homeFloors"
                @input="value => handleChange('homeFloors', value)"
              />
            </div>
            <div class="mb-4">
              <DataCard
                label="Beds"
                :value="lead.homeBedrooms"
                @input="value => handleChange('homeBedrooms', value)"
              />
            </div>
            <div class="mb-4">
              <DataCard
                label="Baths"
                :value="lead.homeBathrooms"
                @input="value => handleChange('homeBathrooms', value)"
              />
            </div>
            <div class="mb-4">
              <DataCard
                label="Square Feet"
                :value="lead.homeSqft"
                @input="value => handleChange('homeSqft', value)"
              />
            </div>
            <div class="mb-4">
              <DataCard
                label="Exterior Doors"
                :value="lead.homeDoorsQty"
                @input="value => handleChange('homeDoorsQty', value)"
              />
            </div>

            <continue-button to="/feature-selection">Continue</continue-button>
          </div>
          <div class="flex-grow relative home-image-container">
            <div
              class="home-image"
              :style="`background-image: url(${homeData.image})`"
            ></div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import ContinueButton from "../components/ContinueButton.vue";
import TruePanel from "../components/TruePanel.vue";
import DataCard from "../components/DataCard.vue";

export default {
  components: {
    ContinueButton,
    TruePanel,
    DataCard
  },

  data: () => ({
    loading: false,
    address: "",
    homeData: {}
  }),

  computed: {
    ...mapState(["lead"]),
    readyToContinue() {
      return;
    }
  },

  methods: {
    async getAddressData(data) {
      const address = data.formatted_address;
      this.address = address;
      await this.$store.dispatch("setAddressFormatted", this.address);
      await this.$store.dispatch("setPlace", data);
      this.getHomeData();
    },

    updateLead(key, value) {
      this.$store.commit("SET_LEAD_VALUE", {
        leadKey: key,
        value: value
      });
    },

    updateHomeDataOnLead() {
      this.updateLead("homeSqft", this.homeData.sqft);
      this.updateLead("homeFloors", this.homeData.floors);
      this.updateLead("homeBasement", this.homeData.hasBasement);
      this.updateLead("homeBedrooms", this.homeData.beds);
      this.updateLead("homeBathrooms", this.homeData.baths);
      this.updateLead("homeDoorsQty", this.homeData.doors);
      this.updateLead("homeImageUrl", this.homeData.image);
      this.updateLead("homeMapImageUrl", this.homeData.mapImage);
    },

    handleChange(leadProperty, value) {
      this.updateLead(leadProperty, value);
    },

    reset() {
      delete localStorage.lead;
      window.location = "/start-over";
    },

    async getHomeData() {
      // let homeDataSet = typeof this.$store.state.lead.homeSqft !== 'undefined' && this.$store.state.lead.homeSqft !== null;
      let homeDataSet = false;

      if (!homeDataSet) {
        this.loading = true;

        let res;

        try {
          res = await axios.get(`/ajax/home-data?address=${this.address}`);

          if (!res.data) {
            throw new Error("Bad address");
          }

          this.homeData = res.data;
          this.loading = false;
          this.updateHomeDataOnLead();
        } catch (e) {
          return this.handleAddressError();
        }
      }

      this.homeData = {
        sqft: this.lead.homeSqft,
        floors: this.lead.homeFloors,
        hasBasement: this.lead.homeBasement,
        beds: this.lead.homeBedrooms,
        baths: this.lead.homeBathrooms,
        doors: this.lead.homeDoorsQty,
        mapImage: this.lead.homeMapImageUrl,
        image: this.lead.homeImageUrl
      };
    },

    handleAddressError() {
      alert("There was an error with the address provided");
      this.address = null;
      this.loading = false;
    }
  },

  async mounted() {
    let address = this.$store.state.lead.addressFormatted;

    if (address) {
      this.address = address;
    }

    if (this.$router.currentRoute.query.address) {
      this.address = this.$router.currentRoute.query.address;
      this.$store.dispatch("setAddressFormatted", this.address);
    }

    if (this.address) {
      this.getHomeData();
    }
  }
};
</script>

<style lang="scss" scoped>
.relative {
  position: relative;
}

.empty-container {
  max-width: 500px;
  margin: 0 auto;

  h1 {
    font-size: 1.75rem;
  }
}

.homeOverviewContainer {
  max-width: 1400px;
  margin: 0 auto;
  @media (max-width: 768px) {
    max-width: 600px;
  }
}

.homeInfo {
  margin-right: 120px;
  @media (max-width: 768px) {
    margin-right: 0;
    width: 100%;
  }
}

.map-image {
  object-fit: cover;
  height: 100%;
  margin-right: 1rem;
}

.home-image-container {
  @media (max-width: 768px) {
    display: none;
  }
}

.home-image-mobile {
  display: none;
  @media (max-width: 768px) {
    display: block;
    width: 100%;
    padding-top: 56.25%;
    background-size: cover;
    background-position: center;
    margin-bottom: 1rem;
  }
}

.home-image {
  padding-top: 56.25%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-size: cover;
  background-position: center;
  height: 100%;
  object-fit: cover;
  img {
    top: 0;
    height: 100%;
    object-fit: cover;
  }
}

.map-marker {
  width: 28px;
  margin: 0.5rem;
}
</style>
